export const Add_To_Cart ='Add_To_Cart';
export const Remove_To_Cart = 'Remove_To_Cart';
export const Update_Profile = 'Update_Profile';
export const GET_WALLET = 'GET_WALLET';